import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "formContainer"];
  static outlets = ["admin--zendesk-form-select"];
  static values = {
    supportsFieldMappings: Array,
    integrationTypes: Object,
    formsUrlTemplate: String,
  };

  connect() {
    requestAnimationFrame(() => this.toggle());
  }

  toggle() {
    const hiddenInput = this.selectTarget.querySelector('input[type="hidden"]');
    const selectedId = parseInt(hiddenInput?.value || this.selectTarget.value, 10);

    if (!selectedId) return;

    const shouldShow = this.supportsFieldMappingsValue.includes(selectedId);

    this.formContainerTarget.hidden = !shouldShow;

    if (shouldShow) {
      const integrationType = this.integrationTypesValue[selectedId];
      const fieldDivs = this.formContainerTarget.querySelectorAll("[data-integration-type]");

      fieldDivs.forEach((div) => {
        div.hidden = div.dataset.integrationType !== integrationType;
      });

      if (integrationType === "ZendeskTicketingIntegration" && this.hasFormsUrlTemplateValue) {
        if (this.hasAdminZendeskFormSelectOutlet) {
          this.adminZendeskFormSelectOutlet.setIntegrationId(selectedId);
        }

        const turboFrame = this.formContainerTarget.querySelector(
          "turbo-frame#ticket_form_id_select"
        );
        if (turboFrame && !turboFrame.getAttribute("src")) {
          const url = new URL(
            this.formsUrlTemplateValue.replace("__INTEGRATION_ID__", selectedId),
            window.location.origin
          );
          url.searchParams.set("field_name", turboFrame.dataset.fieldName);
          if (turboFrame.dataset.selectedValue) {
            url.searchParams.set("selected", turboFrame.dataset.selectedValue);
          }
          turboFrame.setAttribute("src", url.pathname + url.search);
        }
      }
    }
  }
}
